// // Section configs for the generic CopperLayer.
// // Each section maps to a copper-api endpoint and describes how to render it.

// const fmtNum = (v) => {
//   if (v === undefined || v === null || v === "") return "—";
//   const n = Number(v);
//   if (!Number.isFinite(n)) return String(v);
//   return n.toLocaleString(undefined, { maximumFractionDigits: 8 });
// };

// // Timezone is global state held here so plain render functions (which run
// // inside table closures, not React components) can read the current tz
// // without prop-drilling. The TimezoneProvider keeps this in sync with React
// // state so consumers re-render when the user changes it.
// const DEFAULT_TIMEZONE = "Asia/Kolkata";
// let currentTimezone = DEFAULT_TIMEZONE;

// const TIMEZONE_OPTIONS = [
//   { value: "UTC", short: "UTC", label: "UTC", region: "Coordinated Universal Time" },
//   { value: "Asia/Kolkata", short: "IST", label: "India", region: "Kolkata · GMT+5:30" },
//   { value: "Europe/London", short: "GMT", label: "United Kingdom", region: "London · GMT/BST" },
//   { value: "America/New_York", short: "ET", label: "US East", region: "New York · ET" },
//   { value: "America/Los_Angeles", short: "PT", label: "US West", region: "Los Angeles · PT" },
//   { value: "Asia/Singapore", short: "SGT", label: "Singapore", region: "Singapore · GMT+8" },
//   { value: "Asia/Dubai", short: "GST", label: "UAE", region: "Dubai · GMT+4" },
//   { value: "Asia/Tokyo", short: "JST", label: "Japan", region: "Tokyo · GMT+9" },
//   { value: "Asia/Hong_Kong", short: "HKT", label: "Hong Kong", region: "Hong Kong · GMT+8" },
//   { value: "Australia/Sydney", short: "AEST", label: "Australia", region: "Sydney · AEST/AEDT" },
// ];

// const setCurrentTimezone = (tz) => {
//   currentTimezone = tz || DEFAULT_TIMEZONE;
// };
// const getCurrentTimezone = () => currentTimezone;

// const formatterCache = new Map();
// const buildFormatter = (tz, opts) =>
//   new Intl.DateTimeFormat("en-IN", { timeZone: tz, ...opts });

// const getFormatter = (tz) => {
//   const key = `full|${tz}`;
//   let f = formatterCache.get(key);
//   if (!f) {
//     f = buildFormatter(tz, {
//       year: "numeric",
//       month: "short",
//       day: "2-digit",
//       hour: "2-digit",
//       minute: "2-digit",
//       second: "2-digit",
//       hour12: true,
//       timeZoneName: "short",
//     });
//     formatterCache.set(key, f);
//   }
//   return f;
// };

// const getDateOnlyFormatter = (tz) => {
//   const key = `date|${tz}`;
//   let f = formatterCache.get(key);
//   if (!f) {
//     f = buildFormatter(tz, {
//       year: "numeric",
//       month: "short",
//       day: "2-digit",
//     });
//     formatterCache.set(key, f);
//   }
//   return f;
// };

// const getTimeOnlyFormatter = (tz) => {
//   const key = `time|${tz}`;
//   let f = formatterCache.get(key);
//   if (!f) {
//     f = buildFormatter(tz, {
//       hour: "2-digit",
//       minute: "2-digit",
//       second: "2-digit",
//       hour12: true,
//       timeZoneName: "short",
//     });
//     formatterCache.set(key, f);
//   }
//   return f;
// };

// // Parse a Copper date value to epoch ms. Handles numeric strings (their
// // usual shape), real numbers, and ISO strings. Returns NaN on failure.
// const toEpochMs = (v) => {
//   if (v === undefined || v === null || v === "") return NaN;
//   if (typeof v === "number") return v;
//   const str = String(v).trim();
//   if (/^-?\d+$/.test(str)) return Number(str);
//   return Date.parse(str);
// };

// const fmtDate = (v) => {
//   if (v === undefined || v === null || v === "") return "—";
//   const ms = toEpochMs(v);
//   if (!Number.isFinite(ms)) return String(v);
//   return getFormatter(currentTimezone).format(new Date(ms));
// };

// // Date portion only (e.g. "30 Apr 2026") in the selected timezone.
// const fmtDateOnly = (v) => {
//   if (v === undefined || v === null || v === "") return "—";
//   const ms = toEpochMs(v);
//   if (!Number.isFinite(ms)) return String(v);
//   return getDateOnlyFormatter(currentTimezone).format(new Date(ms));
// };

// // Time portion only (e.g. "05:40:41 am IST") in the selected timezone.
// const fmtTimeOnly = (v) => {
//   if (v === undefined || v === null || v === "") return "—";
//   const ms = toEpochMs(v);
//   if (!Number.isFinite(ms)) return String(v);
//   return getTimeOnlyFormatter(currentTimezone).format(new Date(ms));
// };

// // YYYY-MM-DD filename stamp in the selected timezone. Replaces the older
// // `new Date().toISOString().split("T")[0]` which always emits UTC and would
// // produce a different day than what the user sees in the table.
// const fmtFileDate = (v) => {
//   const ms = v === undefined || v === null || v === "" ? Date.now() : toEpochMs(v);
//   const stamp = Number.isFinite(ms) ? ms : Date.now();
//   const parts = new Intl.DateTimeFormat("en-CA", {
//     timeZone: currentTimezone,
//     year: "numeric",
//     month: "2-digit",
//     day: "2-digit",
//   }).formatToParts(new Date(stamp));
//   const get = (type) => parts.find((p) => p.type === type)?.value || "";
//   return `${get("year")}-${get("month")}-${get("day")}`;
// };

// // Format any value that *might* be a timestamp/date for tabular export
// // (CSV / PDF). If the value clearly isn't a parseable date, it's returned
// // unchanged so non-date columns aren't mangled.
// const fmtMaybeDate = (v) => {
//   if (v === undefined || v === null || v === "") return "";
//   if (typeof v === "number") return fmtDate(v);
//   const str = String(v).trim();
//   if (str === "") return "";
//   // Pure numeric string — likely epoch ms / s.
//   if (/^-?\d{10,}$/.test(str)) return fmtDate(str);
//   // ISO-ish string — has a date separator + (T or space) + time.
//   if (/^\d{4}-\d{2}-\d{2}[T ]\d/.test(str)) return fmtDate(str);
//   // Plain YYYY-MM-DD — keep as-is (already a calendar date with no tz info).
//   return str;
// };

// const titleCase = (v) => {
//   if (v === undefined || v === null || v === "") return "—";
//   const s = String(v);
//   return s.charAt(0).toUpperCase() + s.slice(1).toLowerCase();
// };

// // Add these helper functions before the CopperLayer component
// const formatAmount = (value) => {
//   if (value === undefined || value === null || value === "") return "—";
  
//   // Handle string numbers from API
//   let num = typeof value === 'string' ? parseFloat(value) : Number(value);
//   if (isNaN(num)) return String(value);
  
//   // Format for display
//   if (Math.abs(num) >= 1000000) {
//     return `${(num / 1000000).toFixed(2)}M`;
//   }
//   if (Math.abs(num) >= 1000) {
//     return `${(num / 1000).toFixed(2)}K`;
//   }
//   if (num < 1 && num > 0 && num.toString().length > 8) {
//     return num.toFixed(8);
//   }
//   return num.toLocaleString(undefined, { 
//     minimumFractionDigits: num % 1 === 0 ? 0 : 2,
//     maximumFractionDigits: 8 
//   });
// };

// const getMarketPrice = (currency) => {
//   // This is a mock - you should replace with actual price fetching
//   const mockPrices = {
//     'USDC': 0.99,
//     'USDT': 0.99,
//     'BTC': 2133.61,
//     'ETH': 2133.61,
//     'SOL': 0,
//     'XRP': 0,
//     'BCH': 0,
//     'XAUT': 4534.92
//   };
//   const price = mockPrices[currency];
//   if (!price || price === 0) return "—";
//   return `$${price.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
// };

// const calculateAllocation = (row) => {
//   // This is a simplified calculation
//   // In reality, you'd need to calculate total portfolio value first
//   // For now, return a placeholder or calculate based on available data
//   const totalBalance = parseFloat(row.totalBalance || row.balance || 0);
//   if (totalBalance === 0) return "0.00%";
  
//   // This needs to be calculated across all wallets
//   // You might want to compute this in a useEffect that sums all balances
//   return "—";
// };

// // Add near your copperApi imports
// const fetchMarketPrices = async (currencies) => {
//   try {
//     // You can use an API like CoinGecko, CoinMarketCap, or your own price feed
//     const response = await fetch(`https://api.coingecko.com/api/v3/simple/price?ids=bitcoin,ethereum,tether,usd-coin&vs_currencies=usd`);
//     const data = await response.json();
//     return {
//       'BTC': data.bitcoin?.usd || 0,
//       'ETH': data.ethereum?.usd || 0,
//       'USDT': data.tether?.usd || 0.99,
//       'USDC': 0.99,
//     };
//   } catch (error) {
//     console.error('Error fetching prices:', error);
//     return {};
//   }
// };

// const COPPER_SECTIONS = {
//   // wallets: {
//   //   title: "Wallets / Balances",
//   //   description: "Wallet balances across portfolios, fetched live from Copper.",
//   //   icon: "solar:wallet-money-bold-duotone",
//   //   endpoint: "/api/wallets",
//   //   listKey: "wallets",
//   //   supportsDateRange: false,
//   //   filters: [
//   //     { key: "currency", label: "Currency", placeholder: "e.g. BTC" },
//   //     { key: "mainCurrency", label: "Main Currency", placeholder: "e.g. USD" },
//   //     {
//   //       key: "portfolioType",
//   //       label: "Portfolio Type",
//   //       type: "select",
//   //       options: [
//   //         { label: "All", value: "" },
//   //         { label: "Custody", value: "custody" },
//   //         { label: "Trading", value: "trading" },
//   //         { label: "External", value: "external" },
//   //       ],
//   //     },
//   //     {
//   //       key: "nonEmpty",
//   //       label: "Show Empty",
//   //       type: "select",
//   //       options: [
//   //         { label: "Hide empty", value: "true" },
//   //         { label: "Show all", value: "false" },
//   //       ],
//   //       defaultValue: "true",
//   //     },
//   //   ],
//   //   columns: [
//   //     { key: "currency", label: "Currency" },
//   //     { key: "mainCurrency", label: "Main" },
//   //     { key: "balance", label: "Balance", render: (r) => fmtNum(r.balance) },
//   //     { key: "available", label: "Available", render: (r) => fmtNum(r.available) },
//   //     { key: "reserved", label: "Reserved", render: (r) => fmtNum(r.reserved) },
//   //     { key: "portfolioType", label: "Portfolio Type" },
//   //     { key: "portfolioId", label: "Portfolio Id" },
//   //     { key: "walletId", label: "Wallet Id" },
//   //   ],
//   // },
  
//   // In copperConfig.js, update the wallets section:
// wallets: {
//   title: "Holdings / Balances",
//   description: "Asset holdings across portfolios with allocation breakdown.",
//   icon: "solar:wallet-money-bold-duotone",
//   endpoint: "/api/wallets",
//   listKey: "wallets",
//   supportsDateRange: false,
//   filters: [
//     { key: "currency", label: "Currency", placeholder: "e.g. BTC" },
//     { key: "mainCurrency", label: "Main Currency", placeholder: "e.g. USD" },
//     {
//       key: "portfolioType",
//       label: "Portfolio Type",
//       type: "select",
//       options: [
//         { label: "All", value: "" },
//         { label: "Custody", value: "custody" },
//         { label: "Trading", value: "trading" },
//         { label: "External", value: "external" },
//       ],
//     },
//     {
//       key: "nonEmpty",
//       label: "Show Empty",
//       type: "select",
//       options: [
//         { label: "Hide empty", value: "true" },
//         { label: "Show all", value: "false" },
//       ],
//       defaultValue: "true",
//     },
//   ],
//   columns: [
//     { 
//       key: "asset", 
//       label: "Asset", 
//       render: (r) => {
//         // Map currency to full asset name
//         const assetNames = {
//           'USDC': 'USD Coin',
//           'USDT': 'Tether',
//           'BTC': 'Bitcoin',
//           'ETH': 'Ethereum',
//           'SOL': 'Solana',
//           'XRP': 'XRP',
//           'BCH': 'Bitcoin Cash',
//           'XAUT': 'Tether Gold'
//         };
//         return assetNames[r.currency] || r.currency || "—";
//       }
//     },
//     { 
//       key: "total", 
//       label: "Total", 
//       render: (r) => {
//         const totalBalance = r.totalBalance || r.balance || "0";
//         return formatAmount(totalBalance);
//       }
//     },
//     { 
//       key: "available", 
//       label: "Available", 
//       render: (r) => formatAmount(r.available)
//     },
//     { 
//       key: "reserved", 
//       label: "Reserved", 
//       render: (r) => formatAmount(r.reserve || r.reserved)
//     },
//     { 
//       key: "clearLoop", 
//       label: "ClearLoop", 
//       render: (r) => {
//         // ClearLoop is typically the locked amount or secured amount
//         const clearLoopAmount = r.locked || r.secured || "0";
//         return formatAmount(clearLoopAmount);
//       }
//     },
//     { 
//       key: "marketPrice", 
//       label: "Market Price", 
//       render: (r) => {
//         // You'll need to fetch market prices separately or from a price API
//         // For now, return a placeholder or fetch from a price oracle
//         return getMarketPrice(r.currency);
//       }
//     },
//     { 
//       key: "allocation", 
//       label: "Allocation", 
//       render: (r) => {
//         // Calculate allocation based on total portfolio value
//         // This requires knowing the total value across all assets
//         return calculateAllocation(r);
//       }
//     },
//     { key: "currency", label: "Currency", render: (r) => r.currency || "—" },
//     { key: "portfolioType", label: "Portfolio Type", render: (r) => r.portfolioType || "—" },
//     { key: "portfolioId", label: "Portfolio Id", render: (r) => r.portfolioId || "—" },
//   ],
// },

//   portfolios: {
//     title: "Portfolios",
//     description: "All portfolios visible to the API key.",
//     icon: "solar:case-round-minimalistic-bold-duotone",
//     endpoint: "/api/portfolios",
//     listKey: "portfolios",
//     supportsDateRange: false,
//     filters: [
//       {
//         key: "portfolioType",
//         label: "Type",
//         type: "select",
//         options: [
//           { label: "All", value: "" },
//           { label: "Custody", value: "custody" },
//           { label: "Trading", value: "trading" },
//           { label: "External", value: "external" },
//         ],
//       },
//     ],
//     columns: [
//       { key: "portfolioId", label: "Portfolio Id" },
//       { key: "displayName", label: "Display Name" },
//       { key: "portfolioType", label: "Type" },
//       { key: "status", label: "Status" },
//       { key: "createdAt", label: "Created", render: (r) => fmtDate(r.createdAt) },
//     ],
//   },

//   currencies: {
//     title: "Currencies",
//     description: "All currencies supported by the connected Copper environment.",
//     icon: "solar:dollar-minimalistic-bold-duotone",
//     endpoint: "/api/currencies",
//     listKey: "currencies",
//     supportsDateRange: false,
//     filters: [],
//     columns: [
//       { key: "currency", label: "Currency" },
//       { key: "name", label: "Name" },
//       { key: "type", label: "Type" },
//       { key: "decimals", label: "Decimals" },
//       { key: "blockchain", label: "Blockchain" },
//       { key: "active", label: "Active", render: (r) => (r.active ? "Yes" : "No") },
//     ],
//   },

//   orders: {
//     title: "Orders (Buy / Sell)",
//     description: "Buy and sell trading orders with date range, status and currency filters.",
//     icon: "solar:cart-large-2-bold-duotone",
//     endpoint: "/api/orders",
//     listKey: "orders",
//     supportsDateRange: true,
//     filters: [
//       {
//         key: "orderTypes",
//         label: "Side",
//         type: "select",
//         options: [
//           { label: "Both", value: "" },
//           { label: "Buy", value: "buy" },
//           { label: "Sell", value: "sell" },
//         ],
//       },
//       { key: "baseCurrency", label: "Base", placeholder: "e.g. BTC" },
//       { key: "mainCurrency", label: "Main", placeholder: "e.g. USD" },
//       {
//         key: "status",
//         label: "Status",
//         type: "select",
//         options: [
//           { label: "All", value: "" },
//           { label: "Filled", value: "filled" },
//           { label: "Open", value: "open" },
//           { label: "Cancelled", value: "cancelled" },
//           { label: "Pending", value: "pending" },
//           { label: "Rejected", value: "rejected" },
//         ],
//       },
//       { key: "portfolioId", label: "Portfolio Id", placeholder: "optional" },
//     ],
//     columns: [
//       { key: "createdAt", label: "Created", render: (r) => fmtDate(r.createdAt) },
//       { key: "orderType", label: "Side", render: (r) => titleCase(r.orderType) },
//       { key: "baseCurrency", label: "Base" },
//       { key: "mainCurrency", label: "Main" },
//       { key: "amount", label: "Amount", render: (r) => fmtNum(r.amount) },
//       { key: "price", label: "Price", render: (r) => fmtNum(r.price) },
//       { key: "fxRate", label: "Fx Rate", render: (r) => fmtNum(r.fxRate) },
//       { key: "status", label: "Status", render: (r) => titleCase(r.status) },
//       { key: "orderId", label: "Order Id" },
//     ],
//   },

//   transfers: {
//     title: "Transfers (Deposits / Withdrawals)",
//     description: "Inbound deposits and outbound withdrawals across portfolios.",
//     icon: "solar:transfer-horizontal-bold-duotone",
//     endpoint: "/api/transfers",
//     listKey: "orders",
//     supportsDateRange: true,
//     filters: [
//       {
//         key: "orderTypes",
//         label: "Direction",
//         type: "select",
//         options: [
//           { label: "Both", value: "" },
//           { label: "Deposit", value: "deposit" },
//           { label: "Withdraw", value: "withdraw" },
//         ],
//       },
//       { key: "baseCurrency", label: "Currency", placeholder: "e.g. BTC" },
//       {
//         key: "status",
//         label: "Status",
//         type: "select",
//         options: [
//           { label: "All", value: "" },
//           { label: "Completed", value: "completed" },
//           { label: "Pending", value: "pending" },
//           { label: "Cancelled", value: "cancelled" },
//           { label: "Rejected", value: "rejected" },
//         ],
//       },
//       { key: "portfolioId", label: "Portfolio Id", placeholder: "optional" },
//     ],
//     columns: [
//       { key: "createdAt", label: "Created", render: (r) => fmtDate(r.createdAt) },
//       { key: "orderType", label: "Direction", render: (r) => titleCase(r.orderType) },
//       { key: "baseCurrency", label: "Currency" },
//       { key: "amount", label: "Amount", render: (r) => fmtNum(r.amount) },
//       { key: "fee", label: "Fee", render: (r) => fmtNum(r.fee) },
//       { key: "status", label: "Status", render: (r) => titleCase(r.status) },
//       { key: "txHash", label: "Tx Hash" },
//       { key: "orderId", label: "Order Id" },
//     ],
//   },

//   trades: {
//     title: "Trades",
//     description: "Executed trade activity (buy/sell) with date range and currency filters.",
//     icon: "solar:chart-square-bold-duotone",
//     endpoint: "/api/trades",
//     listKey: "orders",
//     supportsDateRange: true,
//     filters: [
//       { key: "baseCurrency", label: "Base", placeholder: "e.g. BTC" },
//       { key: "mainCurrency", label: "Main", placeholder: "e.g. USD" },
//       {
//         key: "status",
//         label: "Status",
//         type: "select",
//         options: [
//           { label: "All", value: "" },
//           { label: "Filled", value: "filled" },
//           { label: "Open", value: "open" },
//           { label: "Cancelled", value: "cancelled" },
//           { label: "Pending", value: "pending" },
//         ],
//       },
//       { key: "portfolioId", label: "Portfolio Id", placeholder: "optional" },
//     ],
//     columns: [
//       { key: "createdAt", label: "Created", render: (r) => fmtDate(r.createdAt) },
//       { key: "orderType", label: "Side", render: (r) => titleCase(r.orderType) },
//       { key: "baseCurrency", label: "Base" },
//       { key: "mainCurrency", label: "Main" },
//       { key: "amount", label: "Amount", render: (r) => fmtNum(r.amount) },
//       { key: "price", label: "Price", render: (r) => fmtNum(r.price) },
//       { key: "fxRate", label: "Fx Rate", render: (r) => fmtNum(r.fxRate) },
//       { key: "fee", label: "Fee", render: (r) => fmtNum(r.fee) },
//       { key: "status", label: "Status", render: (r) => titleCase(r.status) },
//       { key: "orderId", label: "Order Id" },
//     ],
//   },

//   addresses: {
//     title: "Addresses",
//     description: "Deposit / whitelist addresses by currency, portfolio and type.",
//     icon: "solar:map-point-bold-duotone",
//     endpoint: "/api/addresses",
//     listKey: "addresses",
//     supportsDateRange: false,
//     filters: [
//       { key: "currency", label: "Currency", placeholder: "e.g. BTC" },
//       { key: "mainCurrency", label: "Main", placeholder: "e.g. USD" },
//       { key: "portfolioId", label: "Portfolio Id", placeholder: "optional" },
//       {
//         key: "addressType",
//         label: "Type",
//         type: "select",
//         options: [
//           { label: "All", value: "" },
//           { label: "Deposit", value: "deposit" },
//           { label: "Whitelist", value: "whitelist" },
//         ],
//       },
//     ],
//     columns: [
//       { key: "address", label: "Address" },
//       { key: "currency", label: "Currency" },
//       { key: "addressType", label: "Type" },
//       { key: "portfolioType", label: "Portfolio Type" },
//       { key: "portfolioId", label: "Portfolio Id" },
//       { key: "label", label: "Label" },
//       { key: "addressId", label: "Address Id" },
//     ],
//   },

// };

// export {
//   COPPER_SECTIONS,
//   fmtNum,
//   fmtDate,
//   fmtDateOnly,
//   fmtTimeOnly,
//   fmtFileDate,
//   fmtMaybeDate,
//   titleCase,
//   toEpochMs,
//   TIMEZONE_OPTIONS,
//   DEFAULT_TIMEZONE,
//   setCurrentTimezone,
//   getCurrentTimezone,
// };


// Section configs for the generic CopperLayer.
// Each section maps to a copper-api endpoint and describes how to render it.

// const fmtNum = (v) => {
//   if (v === undefined || v === null || v === "") return "—";
//   const n = Number(v);
//   if (!Number.isFinite(n)) return String(v);
//   return n.toLocaleString(undefined, { maximumFractionDigits: 8 });
// };

// // Portfolio ID to Name mapping
// const PORTFOLIO_NAMES = {
//   'cmbgrz0gf002h3p6qljckra2x': 'BAC Digital Asset Fund Protected Cell',
//   'cme1j2z1q002h3p6k3klylytp': 'Invoices',
//   'cmi8xtixx008c3p6rhi03rfrc': 'USDC Rewards',
//   'cmi8xrjpd00883p6rm3vrmgye': 'AI Wealth Capital Fund Protected Cell'
// };

// // Helper function to get portfolio display name
// const getPortfolioName = (portfolioId) => {
//   if (!portfolioId) return "—";
//   return PORTFOLIO_NAMES[portfolioId] || portfolioId;
// };

// // Timezone is global state held here so plain render functions (which run
// // inside table closures, not React components) can read the current tz
// // without prop-drilling. The TimezoneProvider keeps this in sync with React
// // state so consumers re-render when the user changes it.
// const DEFAULT_TIMEZONE = "Asia/Kolkata";
// let currentTimezone = DEFAULT_TIMEZONE;

// const TIMEZONE_OPTIONS = [
//   { value: "UTC", short: "UTC", label: "UTC", region: "Coordinated Universal Time" },
//   { value: "Asia/Kolkata", short: "IST", label: "India", region: "Kolkata · GMT+5:30" },
//   { value: "Europe/London", short: "GMT", label: "United Kingdom", region: "London · GMT/BST" },
//   { value: "America/New_York", short: "ET", label: "US East", region: "New York · ET" },
//   { value: "America/Los_Angeles", short: "PT", label: "US West", region: "Los Angeles · PT" },
//   { value: "Asia/Singapore", short: "SGT", label: "Singapore", region: "Singapore · GMT+8" },
//   { value: "Asia/Dubai", short: "GST", label: "UAE", region: "Dubai · GMT+4" },
//   { value: "Asia/Tokyo", short: "JST", label: "Japan", region: "Tokyo · GMT+9" },
//   { value: "Asia/Hong_Kong", short: "HKT", label: "Hong Kong", region: "Hong Kong · GMT+8" },
//   { value: "Australia/Sydney", short: "AEST", label: "Australia", region: "Sydney · AEST/AEDT" },
// ];

// const setCurrentTimezone = (tz) => {
//   currentTimezone = tz || DEFAULT_TIMEZONE;
// };
// const getCurrentTimezone = () => currentTimezone;

// const formatterCache = new Map();
// const buildFormatter = (tz, opts) =>
//   new Intl.DateTimeFormat("en-IN", { timeZone: tz, ...opts });

// const getFormatter = (tz) => {
//   const key = `full|${tz}`;
//   let f = formatterCache.get(key);
//   if (!f) {
//     f = buildFormatter(tz, {
//       year: "numeric",
//       month: "short",
//       day: "2-digit",
//       hour: "2-digit",
//       minute: "2-digit",
//       second: "2-digit",
//       hour12: true,
//       timeZoneName: "short",
//     });
//     formatterCache.set(key, f);
//   }
//   return f;
// };

// const getDateOnlyFormatter = (tz) => {
//   const key = `date|${tz}`;
//   let f = formatterCache.get(key);
//   if (!f) {
//     f = buildFormatter(tz, {
//       year: "numeric",
//       month: "short",
//       day: "2-digit",
//     });
//     formatterCache.set(key, f);
//   }
//   return f;
// };

// const getTimeOnlyFormatter = (tz) => {
//   const key = `time|${tz}`;
//   let f = formatterCache.get(key);
//   if (!f) {
//     f = buildFormatter(tz, {
//       hour: "2-digit",
//       minute: "2-digit",
//       second: "2-digit",
//       hour12: true,
//       timeZoneName: "short",
//     });
//     formatterCache.set(key, f);
//   }
//   return f;
// };

// // Parse a Copper date value to epoch ms. Handles numeric strings (their
// // usual shape), real numbers, and ISO strings. Returns NaN on failure.
// const toEpochMs = (v) => {
//   if (v === undefined || v === null || v === "") return NaN;
//   if (typeof v === "number") return v;
//   const str = String(v).trim();
//   if (/^-?\d+$/.test(str)) return Number(str);
//   return Date.parse(str);
// };

// const fmtDate = (v) => {
//   if (v === undefined || v === null || v === "") return "—";
//   const ms = toEpochMs(v);
//   if (!Number.isFinite(ms)) return String(v);
//   return getFormatter(currentTimezone).format(new Date(ms));
// };

// const fmtDateOnly = (v) => {
//   if (v === undefined || v === null || v === "") return "—";
//   const ms = toEpochMs(v);
//   if (!Number.isFinite(ms)) return String(v);
//   return getDateOnlyFormatter(currentTimezone).format(new Date(ms));
// };

// const fmtTimeOnly = (v) => {
//   if (v === undefined || v === null || v === "") return "—";
//   const ms = toEpochMs(v);
//   if (!Number.isFinite(ms)) return String(v);
//   return getTimeOnlyFormatter(currentTimezone).format(new Date(ms));
// };

// const fmtFileDate = (v) => {
//   const ms = v === undefined || v === null || v === "" ? Date.now() : toEpochMs(v);
//   const stamp = Number.isFinite(ms) ? ms : Date.now();
//   const parts = new Intl.DateTimeFormat("en-CA", {
//     timeZone: currentTimezone,
//     year: "numeric",
//     month: "2-digit",
//     day: "2-digit",
//   }).formatToParts(new Date(stamp));
//   const get = (type) => parts.find((p) => p.type === type)?.value || "";
//   return `${get("year")}-${get("month")}-${get("day")}`;
// };

// const fmtMaybeDate = (v) => {
//   if (v === undefined || v === null || v === "") return "";
//   if (typeof v === "number") return fmtDate(v);
//   const str = String(v).trim();
//   if (str === "") return "";
//   if (/^-?\d{10,}$/.test(str)) return fmtDate(str);
//   if (/^\d{4}-\d{2}-\d{2}[T ]\d/.test(str)) return fmtDate(str);
//   return str;
// };

// const titleCase = (v) => {
//   if (v === undefined || v === null || v === "") return "—";
//   const s = String(v);
//   return s.charAt(0).toUpperCase() + s.slice(1).toLowerCase();
// };

// const formatAmount = (value) => {
//   if (value === undefined || value === null || value === "") return "—";
  
//   let num = typeof value === 'string' ? parseFloat(value) : Number(value);
//   if (isNaN(num)) return String(value);
  
//   if (Math.abs(num) >= 1000000) {
//     return `${(num / 1000000).toFixed(2)}M`;
//   }
//   if (Math.abs(num) >= 1000) {
//     return `${(num / 1000).toFixed(2)}K`;
//   }
//   if (num < 1 && num > 0 && num.toString().length > 8) {
//     return num.toFixed(8);
//   }
//   return num.toLocaleString(undefined, { 
//     minimumFractionDigits: num % 1 === 0 ? 0 : 2,
//     maximumFractionDigits: 8 
//   });
// };

// const COPPER_SECTIONS = {
//   wallets: {
//     title: "Holdings / Balances",
//     description: "Asset holdings across portfolios with allocation breakdown.",
//     icon: "solar:wallet-money-bold-duotone",
//     endpoint: "/api/wallets",
//     listKey: "wallets",
//     supportsDateRange: false,
//     filters: [
//       { key: "currency", label: "Currency", placeholder: "e.g. BTC" },
//       { key: "mainCurrency", label: "Main Currency", placeholder: "e.g. USD" },
//       {
//         key: "portfolioType",
//         label: "Portfolio Type",
//         type: "select",
//         options: [
//           { label: "All", value: "" },
//           { label: "Custody", value: "custody" },
//           { label: "Trading", value: "trading" },
//           { label: "External", value: "external" },
//         ],
//       },
//       {
//         key: "nonEmpty",
//         label: "Show Empty",
//         type: "select",
//         options: [
//           { label: "Hide empty", value: "true" },
//           { label: "Show all", value: "false" },
//         ],
//         defaultValue: "true",
//       },
//     ],
//     columns: [
//       { 
//         key: "asset", 
//         label: "Asset", 
//         render: (r) => {
//           const assetNames = {
//             'USDC': 'USD Coin',
//             'USDT': 'Tether',
//             'BTC': 'Bitcoin',
//             'ETH': 'Ethereum',
//             'SOL': 'Solana',
//             'XRP': 'XRP',
//             'BCH': 'Bitcoin Cash',
//             'XAUT': 'Tether Gold'
//           };
//           return assetNames[r.currency] || r.currency || "—";
//         }
//       },
//       { 
//         key: "total", 
//         label: "Total", 
//         render: (r) => {
//           const totalBalance = r.totalBalance || r.balance || "0";
//           return formatAmount(totalBalance);
//         }
//       },
//       { 
//         key: "available", 
//         label: "Available", 
//         render: (r) => formatAmount(r.available)
//       },
//       { 
//         key: "reserved", 
//         label: "Reserved", 
//         render: (r) => formatAmount(r.reserve || r.reserved || "0")
//       },
//       { 
//         key: "clearLoop", 
//         label: "ClearLoop", 
//         render: (r) => formatAmount(r.locked || r.secured || "0")
//       },
//       { 
//         key: "marketPrice", 
//         label: "Market Price", 
//         render: (r) => "—" // Will be handled by component with real prices
//       },
//       { 
//         key: "allocation", 
//         label: "Allocation", 
//         render: (r) => "—" // Will be handled by component
//       },
//       { key: "currency", label: "Currency", render: (r) => r.currency || "—" },
//       { key: "portfolioType", label: "Portfolio Type", render: (r) => r.portfolioType || "—" },
//       { 
//         key: "portfolioId", 
//         label: "Portfolio Name", 
//         render: (r) => getPortfolioName(r.portfolioId)
//       },
//     ],
//   },

//   portfolios: {
//     title: "Portfolios",
//     description: "All portfolios visible to the API key.",
//     icon: "solar:case-round-minimalistic-bold-duotone",
//     endpoint: "/api/portfolios",
//     listKey: "portfolios",
//     supportsDateRange: false,
//     filters: [
//       {
//         key: "portfolioType",
//         label: "Type",
//         type: "select",
//         options: [
//           { label: "All", value: "" },
//           { label: "Custody", value: "custody" },
//           { label: "Trading", value: "trading" },
//           { label: "External", value: "external" },
//         ],
//       },
//     ],
//     columns: [
//       { key: "portfolioId", label: "Portfolio Id" },
//       { 
//         key: "displayName", 
//         label: "Display Name",
//         render: (r) => getPortfolioName(r.portfolioId)
//       },
//       { key: "portfolioType", label: "Type" },
//       { key: "status", label: "Status" },
//       { key: "createdAt", label: "Created", render: (r) => fmtDate(r.createdAt) },
//     ],
//   },

//   currencies: {
//     title: "Currencies",
//     description: "All currencies supported by the connected Copper environment.",
//     icon: "solar:dollar-minimalistic-bold-duotone",
//     endpoint: "/api/currencies",
//     listKey: "currencies",
//     supportsDateRange: false,
//     filters: [],
//     columns: [
//       { key: "currency", label: "Currency" },
//       { key: "name", label: "Name" },
//       { key: "type", label: "Type" },
//       { key: "decimals", label: "Decimals" },
//       { key: "blockchain", label: "Blockchain" },
//       { key: "active", label: "Active", render: (r) => (r.active ? "Yes" : "No") },
//     ],
//   },

//   orders: {
//     title: "Orders (Buy / Sell)",
//     description: "Buy and sell trading orders with date range, status and currency filters.",
//     icon: "solar:cart-large-2-bold-duotone",
//     endpoint: "/api/orders",
//     listKey: "orders",
//     supportsDateRange: true,
//     filters: [
//       {
//         key: "orderTypes",
//         label: "Side",
//         type: "select",
//         options: [
//           { label: "Both", value: "" },
//           { label: "Buy", value: "buy" },
//           { label: "Sell", value: "sell" },
//         ],
//       },
//       { key: "baseCurrency", label: "Base", placeholder: "e.g. BTC" },
//       { key: "mainCurrency", label: "Main", placeholder: "e.g. USD" },
//       {
//         key: "status",
//         label: "Status",
//         type: "select",
//         options: [
//           { label: "All", value: "" },
//           { label: "Filled", value: "filled" },
//           { label: "Open", value: "open" },
//           { label: "Cancelled", value: "cancelled" },
//           { label: "Pending", value: "pending" },
//           { label: "Rejected", value: "rejected" },
//         ],
//       },
//       { key: "portfolioId", label: "Portfolio Id", placeholder: "optional" },
//     ],
//     columns: [
//       { key: "createdAt", label: "Created", render: (r) => fmtDate(r.createdAt) },
//       { key: "orderType", label: "Side", render: (r) => titleCase(r.orderType) },
//       { key: "baseCurrency", label: "Base" },
//       { key: "mainCurrency", label: "Main" },
//       { key: "amount", label: "Amount", render: (r) => fmtNum(r.amount) },
//       { key: "price", label: "Price", render: (r) => fmtNum(r.price) },
//       { key: "fxRate", label: "Fx Rate", render: (r) => fmtNum(r.fxRate) },
//       { key: "status", label: "Status", render: (r) => titleCase(r.status) },
//       { key: "orderId", label: "Order Id" },
//       { 
//         key: "portfolioId", 
//         label: "Portfolio Name", 
//         render: (r) => getPortfolioName(r.portfolioId)
//       },
//     ],
//   },

//   transfers: {
//     title: "Transfers (Deposits / Withdrawals)",
//     description: "Inbound deposits and outbound withdrawals across portfolios.",
//     icon: "solar:transfer-horizontal-bold-duotone",
//     endpoint: "/api/transfers",
//     listKey: "orders",
//     supportsDateRange: true,
//     filters: [
//       {
//         key: "orderTypes",
//         label: "Direction",
//         type: "select",
//         options: [
//           { label: "Both", value: "" },
//           { label: "Deposit", value: "deposit" },
//           { label: "Withdraw", value: "withdraw" },
//         ],
//       },
//       { key: "baseCurrency", label: "Currency", placeholder: "e.g. BTC" },
//       {
//         key: "status",
//         label: "Status",
//         type: "select",
//         options: [
//           { label: "All", value: "" },
//           { label: "Completed", value: "completed" },
//           { label: "Pending", value: "pending" },
//           { label: "Cancelled", value: "cancelled" },
//           { label: "Rejected", value: "rejected" },
//         ],
//       },
//       { key: "portfolioId", label: "Portfolio Id", placeholder: "optional" },
//     ],
//     columns: [
//       { key: "createdAt", label: "Created", render: (r) => fmtDate(r.createdAt) },
//       { key: "orderType", label: "Direction", render: (r) => titleCase(r.orderType) },
//       { key: "baseCurrency", label: "Currency" },
//       { key: "amount", label: "Amount", render: (r) => fmtNum(r.amount) },
//       { key: "fee", label: "Fee", render: (r) => fmtNum(r.fee) },
//       { key: "status", label: "Status", render: (r) => titleCase(r.status) },
//       { key: "txHash", label: "Tx Hash" },
//       { key: "orderId", label: "Order Id" },
//       { 
//         key: "portfolioId", 
//         label: "Portfolio Name", 
//         render: (r) => getPortfolioName(r.portfolioId)
//       },
//     ],
//   },

//   trades: {
//     title: "Trades",
//     description: "Executed trade activity (buy/sell) with date range and currency filters.",
//     icon: "solar:chart-square-bold-duotone",
//     endpoint: "/api/trades",
//     listKey: "orders",
//     supportsDateRange: true,
//     filters: [
//       { key: "baseCurrency", label: "Base", placeholder: "e.g. BTC" },
//       { key: "mainCurrency", label: "Main", placeholder: "e.g. USD" },
//       {
//         key: "status",
//         label: "Status",
//         type: "select",
//         options: [
//           { label: "All", value: "" },
//           { label: "Filled", value: "filled" },
//           { label: "Open", value: "open" },
//           { label: "Cancelled", value: "cancelled" },
//           { label: "Pending", value: "pending" },
//         ],
//       },
//       { key: "portfolioId", label: "Portfolio Id", placeholder: "optional" },
//     ],
//     columns: [
//       { key: "createdAt", label: "Created", render: (r) => fmtDate(r.createdAt) },
//       { key: "orderType", label: "Side", render: (r) => titleCase(r.orderType) },
//       { key: "baseCurrency", label: "Base" },
//       { key: "mainCurrency", label: "Main" },
//       { key: "amount", label: "Amount", render: (r) => fmtNum(r.amount) },
//       { key: "price", label: "Price", render: (r) => fmtNum(r.price) },
//       { key: "fxRate", label: "Fx Rate", render: (r) => fmtNum(r.fxRate) },
//       { key: "fee", label: "Fee", render: (r) => fmtNum(r.fee) },
//       { key: "status", label: "Status", render: (r) => titleCase(r.status) },
//       { key: "orderId", label: "Order Id" },
//       { 
//         key: "portfolioId", 
//         label: "Portfolio Name", 
//         render: (r) => getPortfolioName(r.portfolioId)
//       },
//     ],
//   },

//   addresses: {
//     title: "Addresses",
//     description: "Deposit / whitelist addresses by currency, portfolio and type.",
//     icon: "solar:map-point-bold-duotone",
//     endpoint: "/api/addresses",
//     listKey: "addresses",
//     supportsDateRange: false,
//     filters: [
//       { key: "currency", label: "Currency", placeholder: "e.g. BTC" },
//       { key: "mainCurrency", label: "Main", placeholder: "e.g. USD" },
//       { key: "portfolioId", label: "Portfolio Id", placeholder: "optional" },
//       {
//         key: "addressType",
//         label: "Type",
//         type: "select",
//         options: [
//           { label: "All", value: "" },
//           { label: "Deposit", value: "deposit" },
//           { label: "Whitelist", value: "whitelist" },
//         ],
//       },
//     ],
//     columns: [
//       { key: "address", label: "Address" },
//       { key: "currency", label: "Currency" },
//       { key: "addressType", label: "Type" },
//       { key: "portfolioType", label: "Portfolio Type" },
//       { 
//         key: "portfolioId", 
//         label: "Portfolio Name", 
//         render: (r) => getPortfolioName(r.portfolioId)
//       },
//       { key: "label", label: "Label" },
//       { key: "addressId", label: "Address Id" },
//     ],
//   },
// };

// export {
//   COPPER_SECTIONS,
//   fmtNum,
//   fmtDate,
//   fmtDateOnly,
//   fmtTimeOnly,
//   fmtFileDate,
//   fmtMaybeDate,
//   titleCase,
//   toEpochMs,
//   TIMEZONE_OPTIONS,
//   DEFAULT_TIMEZONE,
//   setCurrentTimezone,
//   getCurrentTimezone,
//   formatAmount,
//   getPortfolioName,
//   PORTFOLIO_NAMES,
// };

// Section configs for the generic CopperLayer.
// Each section maps to a copper-api endpoint and describes how to render it.

const fmtNum = (v) => {
  if (v === undefined || v === null || v === "") return "—";
  const n = Number(v);
  if (!Number.isFinite(n)) return String(v);
  return n.toLocaleString(undefined, { maximumFractionDigits: 8 });
};

// Portfolio ID to Name mapping
const PORTFOLIO_NAMES = {
  'cmbgrz0gf002h3p6qljckra2x': 'BAC Digital Asset Fund Protected Cell',
  'cme1j2z1q002h3p6k3klylytp': 'Invoices',
  'cmi8xtixx008c3p6rhi03rfrc': 'USDC Rewards',
  'cmi8xrjpd00883p6rm3vrmgye': 'AI Wealth Capital Fund Protected Cell'
};

// Helper function to get portfolio display name
const getPortfolioName = (portfolioId) => {
  if (!portfolioId) return "—";
  return PORTFOLIO_NAMES[portfolioId] || portfolioId;
};

// Timezone is global state held here so plain render functions (which run
// inside table closures, not React components) can read the current tz
// without prop-drilling. The TimezoneProvider keeps this in sync with React
// state so consumers re-render when the user changes it.
const DEFAULT_TIMEZONE = "Asia/Kolkata";
let currentTimezone = DEFAULT_TIMEZONE;

const TIMEZONE_OPTIONS = [
  { value: "UTC", short: "UTC", label: "UTC", region: "Coordinated Universal Time" },
  { value: "Asia/Kolkata", short: "IST", label: "India", region: "Kolkata · GMT+5:30" },
  { value: "Europe/London", short: "GMT", label: "United Kingdom", region: "London · GMT/BST" },
  { value: "America/New_York", short: "ET", label: "US East", region: "New York · ET" },
  { value: "America/Los_Angeles", short: "PT", label: "US West", region: "Los Angeles · PT" },
  { value: "Asia/Singapore", short: "SGT", label: "Singapore", region: "Singapore · GMT+8" },
  { value: "Asia/Dubai", short: "GST", label: "UAE", region: "Dubai · GMT+4" },
  { value: "Asia/Tokyo", short: "JST", label: "Japan", region: "Tokyo · GMT+9" },
  { value: "Asia/Hong_Kong", short: "HKT", label: "Hong Kong", region: "Hong Kong · GMT+8" },
  { value: "Australia/Sydney", short: "AEST", label: "Australia", region: "Sydney · AEST/AEDT" },
];

const setCurrentTimezone = (tz) => {
  currentTimezone = tz || DEFAULT_TIMEZONE;
};
const getCurrentTimezone = () => currentTimezone;

const formatterCache = new Map();
const buildFormatter = (tz, opts) =>
  new Intl.DateTimeFormat("en-IN", { timeZone: tz, ...opts });

const getFormatter = (tz) => {
  const key = `full|${tz}`;
  let f = formatterCache.get(key);
  if (!f) {
    f = buildFormatter(tz, {
      year: "numeric",
      month: "short",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: true,
      timeZoneName: "short",
    });
    formatterCache.set(key, f);
  }
  return f;
};

const getDateOnlyFormatter = (tz) => {
  const key = `date|${tz}`;
  let f = formatterCache.get(key);
  if (!f) {
    f = buildFormatter(tz, {
      year: "numeric",
      month: "short",
      day: "2-digit",
    });
    formatterCache.set(key, f);
  }
  return f;
};

const getTimeOnlyFormatter = (tz) => {
  const key = `time|${tz}`;
  let f = formatterCache.get(key);
  if (!f) {
    f = buildFormatter(tz, {
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: true,
      timeZoneName: "short",
    });
    formatterCache.set(key, f);
  }
  return f;
};

// Parse a Copper date value to epoch ms. Handles numeric strings (their
// usual shape), real numbers, and ISO strings. Returns NaN on failure.
const toEpochMs = (v) => {
  if (v === undefined || v === null || v === "") return NaN;
  if (typeof v === "number") return v;
  const str = String(v).trim();
  if (/^-?\d+$/.test(str)) return Number(str);
  return Date.parse(str);
};

const fmtDate = (v) => {
  if (v === undefined || v === null || v === "") return "—";
  const ms = toEpochMs(v);
  if (!Number.isFinite(ms)) return String(v);
  return getFormatter(currentTimezone).format(new Date(ms));
};

const fmtDateOnly = (v) => {
  if (v === undefined || v === null || v === "") return "—";
  const ms = toEpochMs(v);
  if (!Number.isFinite(ms)) return String(v);
  return getDateOnlyFormatter(currentTimezone).format(new Date(ms));
};

const fmtTimeOnly = (v) => {
  if (v === undefined || v === null || v === "") return "—";
  const ms = toEpochMs(v);
  if (!Number.isFinite(ms)) return String(v);
  return getTimeOnlyFormatter(currentTimezone).format(new Date(ms));
};

const fmtFileDate = (v) => {
  const ms = v === undefined || v === null || v === "" ? Date.now() : toEpochMs(v);
  const stamp = Number.isFinite(ms) ? ms : Date.now();
  const parts = new Intl.DateTimeFormat("en-CA", {
    timeZone: currentTimezone,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).formatToParts(new Date(stamp));
  const get = (type) => parts.find((p) => p.type === type)?.value || "";
  return `${get("year")}-${get("month")}-${get("day")}`;
};

const fmtMaybeDate = (v) => {
  if (v === undefined || v === null || v === "") return "";
  if (typeof v === "number") return fmtDate(v);
  const str = String(v).trim();
  if (str === "") return "";
  if (/^-?\d{10,}$/.test(str)) return fmtDate(str);
  if (/^\d{4}-\d{2}-\d{2}[T ]\d/.test(str)) return fmtDate(str);
  return str;
};

const titleCase = (v) => {
  if (v === undefined || v === null || v === "") return "—";
  const s = String(v);
  return s.charAt(0).toUpperCase() + s.slice(1).toLowerCase();
};

const formatAmount = (value) => {
  if (value === undefined || value === null || value === "") return "—";
  
  let num = typeof value === 'string' ? parseFloat(value) : Number(value);
  if (isNaN(num)) return String(value);
  
  if (Math.abs(num) >= 1000000) {
    return `${(num / 1000000).toFixed(2)}M`;
  }
  if (Math.abs(num) >= 1000) {
    return `${(num / 1000).toFixed(2)}K`;
  }
  if (num < 1 && num > 0 && num.toString().length > 8) {
    return num.toFixed(8);
  }
  return num.toLocaleString(undefined, { 
    minimumFractionDigits: num % 1 === 0 ? 0 : 2,
    maximumFractionDigits: 8 
  });
};

// Helper function to check if wallet should be filtered out (total balance < 10)
const shouldShowWallet = (wallet) => {
  const totalBalance = parseFloat(wallet.totalBalance || wallet.balance || 0);
  return totalBalance >= 10;
};

// Helper function to filter wallets based on balance
const filterWalletsByBalance = (wallets) => {
  if (!wallets || !Array.isArray(wallets)) return wallets;
  return wallets.filter(shouldShowWallet);
};

const COPPER_SECTIONS = {
  wallets: {
    title: "Holdings / Balances",
    description: "Asset holdings across portfolios with allocation breakdown. Showing wallets with total balance ≥ 10.",
    icon: "solar:wallet-money-bold-duotone",
    endpoint: "/api/wallets",
    listKey: "wallets",
    supportsDateRange: false,
    // Custom post-processing function to filter wallets
    postProcess: (data) => {
      if (data && data.wallets && Array.isArray(data.wallets)) {
        return {
          ...data,
          wallets: filterWalletsByBalance(data.wallets),
          originalCount: data.wallets.length,
          filteredCount: filterWalletsByBalance(data.wallets).length
        };
      }
      return data;
    },
    filters: [
      { key: "currency", label: "Currency", placeholder: "e.g. BTC" },
      { key: "mainCurrency", label: "Main Currency", placeholder: "e.g. USD" },
      {
        key: "portfolioType",
        label: "Portfolio Type",
        type: "select",
        options: [
          { label: "All", value: "" },
          { label: "Custody", value: "custody" },
          { label: "Trading", value: "trading" },
          { label: "External", value: "external" },
        ],
      },
      {
        key: "nonEmpty",
        label: "Show Empty",
        type: "select",
        options: [
          { label: "Hide empty", value: "true" },
          { label: "Show all", value: "false" },
        ],
        defaultValue: "true",
      },
      {
        key: "minBalance",
        label: "Min Balance",
        type: "select",
        options: [
          { label: "≥ 10", value: "10" },
          { label: "≥ 100", value: "100" },
          { label: "≥ 1000", value: "1000" },
          { label: "All", value: "0" },
        ],
        defaultValue: "10",
      },
    ],
    columns: [
      { 
        key: "asset", 
        label: "Asset", 
        render: (r) => {
          const assetNames = {
            'USDC': 'USD Coin',
            'USDT': 'Tether',
            'BTC': 'Bitcoin',
            'ETH': 'Ethereum',
            'SOL': 'Solana',
            'XRP': 'XRP',
            'BCH': 'Bitcoin Cash',
            'XAUT': 'Tether Gold'
          };
          return assetNames[r.currency] || r.currency || "—";
        }
      },
      { 
        key: "total", 
        label: "Total", 
        render: (r) => {
          const totalBalance = r.totalBalance || r.balance || "0";
          return formatAmount(totalBalance);
        }
      },
      { 
        key: "available", 
        label: "Available", 
        render: (r) => formatAmount(r.available)
      },
      { 
        key: "reserved", 
        label: "Reserved", 
        render: (r) => formatAmount(r.reserve || r.reserved || "0")
      },
      { 
        key: "clearLoop", 
        label: "ClearLoop", 
        render: (r) => formatAmount(r.locked || r.secured || "0")
      },
      { 
        key: "marketPrice", 
        label: "Market Price", 
        render: (r) => "—" // Will be handled by component with real prices
      },
      { 
        key: "allocation", 
        label: "Allocation", 
        render: (r) => "—" // Will be handled by component
      },
      { key: "currency", label: "Currency", render: (r) => r.currency || "—" },
      { key: "portfolioType", label: "Portfolio Type", render: (r) => r.portfolioType || "—" },
      { 
        key: "portfolioId", 
        label: "Portfolio Name", 
        render: (r) => getPortfolioName(r.portfolioId)
      },
    ],
  },

  portfolios: {
    title: "Portfolios",
    description: "All portfolios visible to the API key.",
    icon: "solar:case-round-minimalistic-bold-duotone",
    endpoint: "/api/portfolios",
    listKey: "portfolios",
    supportsDateRange: false,
    filters: [
      {
        key: "portfolioType",
        label: "Type",
        type: "select",
        options: [
          { label: "All", value: "" },
          { label: "Custody", value: "custody" },
          { label: "Trading", value: "trading" },
          { label: "External", value: "external" },
        ],
      },
    ],
    columns: [
      { key: "portfolioId", label: "Portfolio Id" },
      { 
        key: "displayName", 
        label: "Display Name",
        render: (r) => getPortfolioName(r.portfolioId)
      },
      { key: "portfolioType", label: "Type" },
      { key: "status", label: "Status" },
      { key: "createdAt", label: "Created", render: (r) => fmtDate(r.createdAt) },
    ],
  },

  currencies: {
    title: "Currencies",
    description: "All currencies supported by the connected Copper environment.",
    icon: "solar:dollar-minimalistic-bold-duotone",
    endpoint: "/api/currencies",
    listKey: "currencies",
    supportsDateRange: false,
    filters: [],
    columns: [
      { key: "currency", label: "Currency" },
      { key: "name", label: "Name" },
      { key: "type", label: "Type" },
      { key: "decimals", label: "Decimals" },
      { key: "blockchain", label: "Blockchain" },
      { key: "active", label: "Active", render: (r) => (r.active ? "Yes" : "No") },
    ],
  },

  orders: {
    title: "Orders (Buy / Sell)",
    description: "Buy and sell trading orders with date range, status and currency filters.",
    icon: "solar:cart-large-2-bold-duotone",
    endpoint: "/api/orders",
    listKey: "orders",
    supportsDateRange: true,
    filters: [
      {
        key: "orderTypes",
        label: "Side",
        type: "select",
        options: [
          { label: "Both", value: "" },
          { label: "Buy", value: "buy" },
          { label: "Sell", value: "sell" },
        ],
      },
      { key: "baseCurrency", label: "Base", placeholder: "e.g. BTC" },
      { key: "mainCurrency", label: "Main", placeholder: "e.g. USD" },
      {
        key: "status",
        label: "Status",
        type: "select",
        options: [
          { label: "All", value: "" },
          { label: "Filled", value: "filled" },
          { label: "Open", value: "open" },
          { label: "Cancelled", value: "cancelled" },
          { label: "Pending", value: "pending" },
          { label: "Rejected", value: "rejected" },
        ],
      },
      { key: "portfolioId", label: "Portfolio Id", placeholder: "optional" },
    ],
    columns: [
      { key: "createdAt", label: "Created", render: (r) => fmtDate(r.createdAt) },
      { key: "orderType", label: "Side", render: (r) => titleCase(r.orderType) },
      { key: "baseCurrency", label: "Base" },
      { key: "mainCurrency", label: "Main" },
      { key: "amount", label: "Amount", render: (r) => fmtNum(r.amount) },
      { key: "price", label: "Price", render: (r) => fmtNum(r.price) },
      { key: "fxRate", label: "Fx Rate", render: (r) => fmtNum(r.fxRate) },
      { key: "status", label: "Status", render: (r) => titleCase(r.status) },
      { key: "orderId", label: "Order Id" },
      { 
        key: "portfolioId", 
        label: "Portfolio Name", 
        render: (r) => getPortfolioName(r.portfolioId)
      },
    ],
  },

  transfers: {
    title: "Transfers (Deposits / Withdrawals)",
    description: "Inbound deposits and outbound withdrawals across portfolios.",
    icon: "solar:transfer-horizontal-bold-duotone",
    endpoint: "/api/transfers",
    listKey: "orders",
    supportsDateRange: true,
    filters: [
      {
        key: "orderTypes",
        label: "Direction",
        type: "select",
        options: [
          { label: "Both", value: "" },
          { label: "Deposit", value: "deposit" },
          { label: "Withdraw", value: "withdraw" },
        ],
      },
      { key: "baseCurrency", label: "Currency", placeholder: "e.g. BTC" },
      {
        key: "status",
        label: "Status",
        type: "select",
        options: [
          { label: "All", value: "" },
          { label: "Completed", value: "completed" },
          { label: "Pending", value: "pending" },
          { label: "Cancelled", value: "cancelled" },
          { label: "Rejected", value: "rejected" },
        ],
      },
      { key: "portfolioId", label: "Portfolio Id", placeholder: "optional" },
    ],
    columns: [
      { key: "createdAt", label: "Created", render: (r) => fmtDate(r.createdAt) },
      { key: "orderType", label: "Direction", render: (r) => titleCase(r.orderType) },
      { key: "baseCurrency", label: "Currency" },
      { key: "amount", label: "Amount", render: (r) => fmtNum(r.amount) },
      { key: "fee", label: "Fee", render: (r) => fmtNum(r.fee) },
      { key: "status", label: "Status", render: (r) => titleCase(r.status) },
      { key: "txHash", label: "Tx Hash" },
      { key: "orderId", label: "Order Id" },
      { 
        key: "portfolioId", 
        label: "Portfolio Name", 
        render: (r) => getPortfolioName(r.portfolioId)
      },
    ],
  },

  trades: {
    title: "Trades",
    description: "Executed trade activity (buy/sell) with date range and currency filters.",
    icon: "solar:chart-square-bold-duotone",
    endpoint: "/api/trades",
    listKey: "orders",
    supportsDateRange: true,
    filters: [
      { key: "baseCurrency", label: "Base", placeholder: "e.g. BTC" },
      { key: "mainCurrency", label: "Main", placeholder: "e.g. USD" },
      {
        key: "status",
        label: "Status",
        type: "select",
        options: [
          { label: "All", value: "" },
          { label: "Filled", value: "filled" },
          { label: "Open", value: "open" },
          { label: "Cancelled", value: "cancelled" },
          { label: "Pending", value: "pending" },
        ],
      },
      { key: "portfolioId", label: "Portfolio Id", placeholder: "optional" },
    ],
    columns: [
      { key: "createdAt", label: "Created", render: (r) => fmtDate(r.createdAt) },
      { key: "orderType", label: "Side", render: (r) => titleCase(r.orderType) },
      { key: "baseCurrency", label: "Base" },
      { key: "mainCurrency", label: "Main" },
      { key: "amount", label: "Amount", render: (r) => fmtNum(r.amount) },
      { key: "price", label: "Price", render: (r) => fmtNum(r.price) },
      { key: "fxRate", label: "Fx Rate", render: (r) => fmtNum(r.fxRate) },
      { key: "fee", label: "Fee", render: (r) => fmtNum(r.fee) },
      { key: "status", label: "Status", render: (r) => titleCase(r.status) },
      { key: "orderId", label: "Order Id" },
      { 
        key: "portfolioId", 
        label: "Portfolio Name", 
        render: (r) => getPortfolioName(r.portfolioId)
      },
    ],
  },

  addresses: {
    title: "Addresses",
    description: "Deposit / whitelist addresses by currency, portfolio and type.",
    icon: "solar:map-point-bold-duotone",
    endpoint: "/api/addresses",
    listKey: "addresses",
    supportsDateRange: false,
    filters: [
      { key: "currency", label: "Currency", placeholder: "e.g. BTC" },
      { key: "mainCurrency", label: "Main", placeholder: "e.g. USD" },
      { key: "portfolioId", label: "Portfolio Id", placeholder: "optional" },
      {
        key: "addressType",
        label: "Type",
        type: "select",
        options: [
          { label: "All", value: "" },
          { label: "Deposit", value: "deposit" },
          { label: "Whitelist", value: "whitelist" },
        ],
      },
    ],
    columns: [
      { key: "address", label: "Address" },
      { key: "currency", label: "Currency" },
      { key: "addressType", label: "Type" },
      { key: "portfolioType", label: "Portfolio Type" },
      { 
        key: "portfolioId", 
        label: "Portfolio Name", 
        render: (r) => getPortfolioName(r.portfolioId)
      },
      { key: "label", label: "Label" },
      { key: "addressId", label: "Address Id" },
    ],
  },
};

export {
  COPPER_SECTIONS,
  fmtNum,
  fmtDate,
  fmtDateOnly,
  fmtTimeOnly,
  fmtFileDate,
  fmtMaybeDate,
  titleCase,
  toEpochMs,
  TIMEZONE_OPTIONS,
  DEFAULT_TIMEZONE,
  setCurrentTimezone,
  getCurrentTimezone,
  formatAmount,
  getPortfolioName,
  PORTFOLIO_NAMES,
  shouldShowWallet,
  filterWalletsByBalance,
};